
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class newRegistrationWithYourCode extends Vue {

    @Prop() item: OM.NewRegistrationWithYourCode;

    onClick(){
        this.$emit('clicked');
    }

}
